export default function flattenTranslations(object, prefix = '') {
  const result = {};
  for (const [key, value] of Object.entries(object)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenTranslations(value, path));
    } else result[path] = value;
  }
  return result;
}